export default {"src":"/_next/static/media/Stripe_Logo.b7b580e7.svg","height":108,"width":260,"blurWidth":0,"blurHeight":0};